import Vue from 'vue';
import Vant, { Lazyload, Notify, Popover, Toast, Dialog, RadioGroup, Radio, Cell, CellGroup, Cascader, Popup, List, ImagePreview } from 'vant';
import App from './App.vue';
import router from './router';
import store from './store';
import 'vant/lib/index.css';
import '@/assets/css/reset.css';
import '@/assets/css/border.css';
import '@/assets/css/font.css';
import environment from './common/environment';
import VConsole from 'vconsole';
import { cookieGet } from '@/common/cookie';
// 使用worker重写默认计时器
import '@/utils/momentum';

// options 为可选参数，无则不传
Vue.use(Lazyload);
Vue.use(Notify);
Vue.use(Popover);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Cascader);
Vue.use(Popup);
Vue.use(List);
Vue.use(ImagePreview);
Vue.use(Vant);
Vue.config.productionTip = false;
Vue.prototype.$env = process.env.NODE_ENV;

Vue.prototype.$browserEnv = environment; // 判断浏览器环境，是微信浏览器还是普通浏览器

// 忽略打开微信小程序的组件
Vue.config.ignoredElements = ['wx-open-launch-weapp'];

function getSentryEnvironment(hostname) {
  // 完全匹配域名
  if (hostname === 'zengzhi.cias.cn') return 'prod';
  return '';
}

const sentryEnvironment = getSentryEnvironment(window.location.hostname);
let vConsole;
if (sentryEnvironment !== 'prod') {
  vConsole = new VConsole();
}
Vue.prototype.$vConsole = vConsole;
// vConsole && vConsole.destroy();

// 头部页面名称
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

// 设置cookie
document.cookie = 'token=' + cookieGet('token') + ';path=/';

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
